import { render, staticRenderFns } from "./individus-scrollalphabet.vue?vue&type=template&id=1de9174d&scoped=true&"
import script from "./individus-scrollalphabet.vue?vue&type=script&lang=ts&"
export * from "./individus-scrollalphabet.vue?vue&type=script&lang=ts&"
import style0 from "./individus-scrollalphabet.vue?vue&type=style&index=0&id=1de9174d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de9174d",
  null
  
)

export default component.exports